// Terminal service for dealing with cyclic-dependencies by emitting on the bus
import store from '../store';
import router from '../router';
import Events from './events.service';
import UserBus from './userBus.service';
import GitBus from './gitBus.service';

async function onSignout() {
  await UserBus.destroy();
  await GitBus.destroy();
}

async function signout() {
  console.log('Requesting signout');
  await store.dispatch('signout');
  await onSignout();
  await router.push('/signin');
}

function setup() {
  console.log('SystemBus setup');
}

Events.$on('requestSignout', signout);
Events.$on('signout', onSignout);

export default {setup};
